/**
 * @module FieldControls
 */
import { FormHelperText, TextField, Typography } from '@material-ui/core';
import { deepMerge } from '@sensenet/client-utils';
import React, { useState } from 'react';
import { changeTemplatedValue } from "../helpers.js";
import { defaultLocalization } from "./localization.js";
/**
 * Field control that represents a ShortText field. Available values will be populated from the FieldSettings.
 */

export const ShortText = props => {
  var _props$localization;

  const localization = deepMerge(defaultLocalization.shortText, (_props$localization = props.localization) === null || _props$localization === void 0 ? void 0 : _props$localization.shortText);
  const [value, setValue] = useState(props.fieldValue || props.actionName === 'new' && changeTemplatedValue(props.settings.DefaultValue) || '');

  const handleChange = e => {
    var _props$fieldOnChange;

    setValue(e.target.value);
    (_props$fieldOnChange = props.fieldOnChange) === null || _props$fieldOnChange === void 0 ? void 0 : _props$fieldOnChange.call(props, props.settings.Name, e.target.value);
  };

  switch (props.actionName) {
    case 'edit':
    case 'new':
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
        autoFocus: props.autoFocus,
        autoComplete: "off",
        name: props.settings.Name,
        id: props.settings.Name,
        label: props.settings.DisplayName,
        InputLabelProps: {
          shrink: true
        },
        value: value,
        required: props.settings.Compulsory,
        disabled: props.settings.ReadOnly,
        inputProps: {
          minLength: props.settings.MinLength,
          maxLength: props.settings.MaxLength,
          pattern: props.settings.Regex
        },
        fullWidth: true,
        onChange: handleChange
      }), !props.hideDescription && /*#__PURE__*/React.createElement(FormHelperText, null, props.settings.Description));

    case 'browse':
    default:
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
        variant: "caption",
        gutterBottom: true
      }, props.settings.DisplayName), /*#__PURE__*/React.createElement(Typography, {
        variant: "body1",
        gutterBottom: true
      }, typeof props.fieldValue === 'object' && props.fieldValue !== null ? '[OBJECT]' : props.fieldValue || localization.noValue));
  }
};
//# sourceMappingURL=short-text.js.map